import ArgumentLabel from '../arguments/ArgumentLabel.jsx';
import ArgumentWrapper from '../arguments/ArgumentWrapper.jsx';
import Select from '../Select.jsx';

const PanelSelect = ({ label, icon, description, valid, helpIconContext, placeholder, value, onChange, options, useSearch, disabled, required, customValue, inputProps = {}, showOptionIcon, className }) => {
  return (
    <ArgumentWrapper className={className}>
      <ArgumentLabel className="small-gap" label={label} icon={icon} description={description} valid={valid} helpIconContext={helpIconContext} isRequired={required} />
      <Select placeholder={placeholder} value={value} onChange={onChange} options={options} useSearch={useSearch} disabled={disabled} customValue={customValue} showOptionIcon={showOptionIcon} {...inputProps} />
    </ArgumentWrapper>
  );
};

export default PanelSelect;
